
//公共库
import { Message } from "element-ui";
import { Component, Vue } from "vue-property-decorator";

//本地引入
import Pagination from "@/comp/Pagination/index.vue";
import { msgSendList, msgSendSave, msgSendRemove } from "@/api/request/bulletin";

//组件
@Component({
  name: "MsgSend",
  components: {
    Pagination,
  },
})

//组件函数
export default class extends Vue {
  //定义变量
  private list: any[] = []; //列表
  private total: number = 0; //总数
  private listLoading: boolean = true; // 列表加载

  //创建时调用
  created() {
    //获取公告列表
    this.getList();
  }

  //请求参数
  private listQuery: any = {
    //页码数据
    page: 0,
    page_size: 20,

    //临时数据
    to_uid_str: "", // 接收人ID
    from_uid_str: "", // 发送人ID

    //请求数据
    to_uid: 0, // 接收人ID
    from_uid: 0, // 发送人ID
  };

  //获取公告列表
  private async getList() {
    //显示列表加载
    this.listLoading = true;

    //数据赋值
    this.listQuery.to_uid = Number(this.listQuery.to_uid_str);
    this.listQuery.from_uid = Number(this.listQuery.from_uid_str);

    //获取数据
    const { data } = await msgSendList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏列表加载
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //发布公告
  private addHandler(): void {
    //数据赋值
    this.msgSendQuery = {
      //临时数据
      from_uid_str: "",

      //临时数据
      from_uid: 0, // 发送人ID
      to_uids: [], // 接收人ID列表
      content: "", // 消息内容
    };
    //发送用户
    this.tags = [];
    this.tagInput = "";
    this.tagInputMore = "";

    //隐藏界面
    this.msgSendDialog = true;
  }

  //处理查询
  private handleFilter(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //删除公告
  private deleteHandler(row: any): void {
    this.$confirm(`您确定要删除消息？`, "警告", {
      type: "warning",
      cancelButtonText: this.$t("permission.cancel") as string,
      confirmButtonText: this.$t("permission.confirm") as string,
    })
      .then(async () => {
        //删除公告
        await msgSendRemove({ id: row.id });

        //显示提示
        this.$message.success("删除成功");

        //获取列表
        this.getList();
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //---------------------------- 发送消息 ----------------------------
  //定义变量
  private tags: any[] = [];
  private tagInput: string = "";
  private tagInputMore: string = "";
  private msgSendDialog: boolean = false;
  private msgSendLoading: boolean = false;

  //用户类型
  private msgSendQuery: any = {
    //临时数据
    from_uid_str: "",

    //临时数据
    from_uid: 0, // 发送人ID
    to_uids: [], // 接收人ID列表
    content: "", // 消息内容
  };

  //添加ID
  private addTag(type: any): void {
    //定义变量
    let errorList: any = [];

    //批量添加
    if (type === "more") {
      //添加数据
      this.tagInputMore
        .trim()
        .split(",")
        .forEach((item) => {
          //移仓处理
          if (!/^[1-9]\d*$/.test(item.trim())) return errorList.push(item.trim());

          //数据赋值
          this.tags.push(item.trim());

          //清空输入框
          this.tagInputMore = "";
        });

      //显示提示
      if (errorList.length) this.$message.error(`${errorList.join(",")}不属于正确格式，请输入数字并以英文格式的逗号进行分隔`);
    } else {
      //验证ID
      if (/^[1-9]\d*$/.test(this.tagInput.trim()) && this.tagInput.trim() !== "") {
        //数据赋值
        this.tags.push(this.tagInput.trim());

        //清空输入框
        this.tagInput = "";
      } else {
        //显示提示
        this.$message.error("请输入正确形式的id");

        //清空输入框
        this.tagInput = "";
      }
    }
  }

  //修改类型
  private async setVipConfirm() {
    //判断返回
    if (this.tags.length == 0) return Message({ message: "请输添加接受人ID", type: "error", duration: 5 * 1000 });
    if (this.msgSendQuery.content == "") return Message({ message: "请输入消息内容", type: "error", duration: 5 * 1000 });
    if (Number(this.msgSendQuery.from_uid_str) == 0) return Message({ message: "请输入发送人ID", type: "error", duration: 5 * 1000 });

    //显示等待
    this.msgSendLoading = true;

    //数据赋值
    this.msgSendQuery.to_uids = [];
    for (var i: number = 0; i < this.tags.length; i++) {
      this.msgSendQuery.to_uids.push(Number(this.tags[i]));
    }
    this.msgSendQuery.from_uid = Number(this.msgSendQuery.from_uid_str);

    //超时隐藏
    setTimeout(() => {
      this.msgSendLoading = false;
    }, 5000);

    //数据请求
    const res = await msgSendSave(this.msgSendQuery);

    //修改成功
    if (res.status === 0) {
      //显示提示
      this.$message.success(`设置成功`);

      //隐藏对话框
      this.msgSendLoading = false;
      this.msgSendDialog = false;

      //获取数据
      this.getList();
    }
  }

  //删除数据
  private removeTag(index: any): void {
    //数据赋值
    this.tags.splice(index, 1);
  }
}
